import envConfig from '../../static/config';
import ApiUtils from './ApiUtils';
import FavouritesActionCreator from '../actions/AccountsActionCreator/FavouritesActionCreator';

const _favouritesEndpointUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/favourites';

export const getFavouriteAccounts = () => {
  let url = envConfig.apiBaseUrlPAAS + _favouritesEndpointUrl;
  if (envConfig.isStubsEnabled) {
    url = envConfig.apiBaseUrlStub + _favouritesEndpointUrl;
  }
  ApiUtils.makeAjaxCall(
    {
      apiVersion: '1.3.0', //TODO:what will this version be ??
      method: 'GET',
      url,
      addAuthToken: true,
    },
    (body) => {
      FavouritesActionCreator.handleAccountsListSuccess(body);
    },
    (error, status) => {
      FavouritesActionCreator.handleAccountsListError(error.error, status);
      console.error(error);
    }
  );
};

const buildModifyFavouritesApiCall =
  ({ successAction, failureAction }) =>
  ({ body, successArg }) => {
    let url = envConfig.apiBaseUrlPAAS + _favouritesEndpointUrl;
    if (envConfig.isStubsEnabled) {
      url = envConfig.apiBaseUrlStub + _favouritesEndpointUrl;
    }

    ApiUtils.makeAjaxCall(
      {
        apiVersion: '1.3.0',
        method: 'PUT',
        url,
        addAuthToken: true,
        requestData: body,
      },
      (_) => {
        successAction(successArg);
      },
      (error, status) => {
        console.error(error);
        if (status === 400) {
          FavouritesActionCreator.handleErrorExceededMaxFavourites(
            error.error,
            status
          );
        }
        failureAction(error.error, status);
      }
    );
  };

export const removeFavouriteAccount = buildModifyFavouritesApiCall({
  successAction: FavouritesActionCreator.handleSuccessResponseRemoveFavourite,
  failureAction: FavouritesActionCreator.handleErrorResponseRemoveFavourite,
});

export const addFavouriteAccount = buildModifyFavouritesApiCall({
  successAction: FavouritesActionCreator.handleSuccessResponseAddFavourite,
  failureAction: FavouritesActionCreator.handleErrorResponseAddFavourite,
});

export const reorderFavouriteAccounts = buildModifyFavouritesApiCall({
  successAction: FavouritesActionCreator.handleSuccessResponseReorderFavourites,
  failureAction: FavouritesActionCreator.handleErrorResponseReorderFavourites,
});
